"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOpCommandHandlerSync = exports.NoOpCommandHandler = exports.VoidCommandHandlerSync = exports.VoidCommandHandler = exports.commandBus = exports.CommandBus = void 0;
require("reflect-metadata");
const tsyringe_1 = require("tsyringe");
class CommandBus {
    constructor(container) {
        this.resolvers = [];
        this.container = container || tsyringe_1.container;
    }
    map(definition, ...data) {
        const promise = this
            .resolve(definition.mapper)
            .then((mapper) => __awaiter(this, void 0, void 0, function* () {
            const handler = yield this.resolve(definition.handler);
            const command = yield mapper.map(data.length > 0 ? data.reduce((a, b) => Object.assign(a, b)) : {});
            return {
                command: command,
                handler,
                execute: (middleware) => {
                    return this.execute({ command: command, handler }, middleware);
                },
            };
        }));
        promise.execute = (...args) => __awaiter(this, void 0, void 0, function* () {
            const result = yield promise;
            return result.execute.apply(this, args);
        });
        return promise;
    }
    execute(definition, middleware) {
        return __awaiter(this, void 0, void 0, function* () {
            const mutableMiddleware = (middleware === null || middleware === void 0 ? void 0 : middleware.concat([])) || [];
            const command = yield this.resolve(definition.command);
            const handler = yield this.resolve(definition.handler);
            const next = (c) => __awaiter(this, void 0, void 0, function* () {
                const current = mutableMiddleware === null || mutableMiddleware === void 0 ? void 0 : mutableMiddleware.shift();
                if (!current) {
                    return handler.handle(c);
                }
                const resolved = yield this.resolve(current);
                return resolved.handle(c, next);
            });
            return next(command);
        });
    }
    resolve(definition) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const resolver of this.resolvers) {
                const result = yield resolver(definition);
                if (result) {
                    return result;
                }
            }
            const definitionType = typeof definition;
            if (definitionType === 'string' ||
                definitionType === 'symbol' ||
                (definitionType === 'function' &&
                    /^class\s/.test(Function.prototype.toString.call(definition)))) {
                return Promise.resolve(this.container.resolve(definition));
            }
            return Promise.resolve(definition);
        });
    }
    beforeResolve(callback) {
    }
    getContainer() {
        return this.container;
    }
}
exports.CommandBus = CommandBus;
exports.commandBus = new CommandBus();
class VoidCommandHandler {
    handle(context) {
        return new Promise((resolve) => resolve());
    }
}
exports.VoidCommandHandler = VoidCommandHandler;
class VoidCommandHandlerSync {
    handle(context) {
        // do nothing
    }
}
exports.VoidCommandHandlerSync = VoidCommandHandlerSync;
class NoOpCommandHandler {
    handle(context) {
        return new Promise((resolve) => resolve(context));
    }
}
exports.NoOpCommandHandler = NoOpCommandHandler;
class NoOpCommandHandlerSync {
    handle(context) {
        return context;
    }
}
exports.NoOpCommandHandlerSync = NoOpCommandHandlerSync;
//# sourceMappingURL=command.js.map